angular.module('picmonicng').factory('nextDomains', [
  'UserService',
  function (UserService) {
    return {
      getLiteDomain: function () {
        let domain = 'https://next.picmonic.com/';

        switch (window.pls_config.app_env) {
          case 'development':
            domain = 'https://next.v2.picmonic.com/';
            break;
          case 'master':
          case 'pr':
            domain = 'https://' + window.location.host.split('.')[0] + '-next.picmonic.com/';
            break;
          case 'production':
            domain = 'https://next.picmonic.com/';
            break;
        }

        return domain;
      },
      getNextUrl: function () {
        var self = this;

        const domain = self.getLiteDomain();

        urlParams = new URLSearchParams(window.location.search);
        urlParams.set('api_key', UserService.user.web_api_key);

        return domain + 'home?' + urlParams.toString();
      },
    };
  },
]);
